<template>
  <div>
    <gmzlr-body />
  </div>
</template>
<script>
import gmzlrBody from '@/components/gmzlr/gmzlrBody.vue'
export default {
  name: 'Gmzlr',
  components: {
    gmzlrBody
  },
  data() {
    return {}
  },
  created: function() {},
  methods: {}
}
</script>
